import {
  getSubjectEducationPeriods,
  findChosenEducationPeriod,
} from 'legacy/src/components/auth/utils';
import { getUserSubjects } from 'legacy/src/reducers/subject';
import * as types from 'legacy/src/constants/types';

// eslint-disable-next-line import/prefer-default-export
export const defaultEducationPeriod = (payload) => ({
  type: types.SET_DEFAULT_EDUCATION_PERIOD,
  payload,
});

export const getDefaultEducationPeriod = ({ subject, userData }) => {
  const subjectEducationPeriods = getSubjectEducationPeriods({
    subjectId: subject,
    teacherSubjects: userData.teacherSubjects,
  });

  const educationPeriodCode = findChosenEducationPeriod({
    currentEducationPeriod: userData.educationPeriod.currentEducationPeriod,
    subjectEducationPeriods,
    me: userData.me,
    userSubjects: getUserSubjects(userData),
    subject,
  });

  return { educationPeriodCode, subjectEducationPeriods };
};

export const clearDefaultEducationPeriod =
  ({ subject, userData }) =>
  (dispatch) => {
    const { educationPeriodCode, subjectEducationPeriods } =
      getDefaultEducationPeriod({
        subject,
        userData,
      });

    return dispatch(
      defaultEducationPeriod({
        educationPeriodCode: educationPeriodCode.id || '',
        subjectEducationPeriods,
        allEducationPeriods: userData.educationPeriod.educationPeriods,
        educationPeriod: userData.educationPeriod,
      }),
    );
  };

export const setDefaultEducationPeriodCode = ({
  educationPeriodCode,
  userData,
}) => ({
  type: types.SET_DEFAULT_EDUCATION_PERIOD,
  payload: {
    educationPeriodCode,
    chosenEducationPeriodCode: educationPeriodCode,
    subjectEducationPeriods: userData.educationPeriod.educationPeriods,
    allEducationPeriods: userData.educationPeriod.educationPeriods,
    educationPeriod: userData.educationPeriod,
  },
});
